












import { Component, Vue } from "vue-property-decorator";
import { api } from "@/api";
import { commitSetBranch } from "@/store/gitlab/mutations";
import { readGitLabInfo } from "@/store/gitlab/getters";
import { dispatchRaiseErrorTimeout } from "@/store/appState/actions";

@Component
export default class SetBranch extends Vue {
  private branches = [];
  private selectedBranch = readGitLabInfo(this.$store).branch;
  private loading = true;

  private async mounted() {
    await this.initialize();
  }

  public async initialize() {
    this.loading = true;
    try {
      this.branches = await api.getBranchesOfProject(
        readGitLabInfo(this.$store).projectId
      );
    } catch (e) {
      await dispatchRaiseErrorTimeout(
        this.$store,
        new Error(`Unable to fetch branches of the selected Project:<br>${e}`)
      );
    }
    this.loading = false;
  }

  private save() {
    if (this.selectedBranch !== "") {
      commitSetBranch(this.$store, this.selectedBranch);
    }
  }
}
